import { ContextStore } from 'bernie-core';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { LegacyPropertySearchCriteriaInput, PrivacyTrackingState } from '__generated__/api';

export const getLegacyCriteria = (searchCriteria: SearchCriteriaModel, context: ContextStore): LegacyPropertySearchCriteriaInput => ({
  sort: searchCriteria.sort,
  stars: searchCriteria.star ? searchCriteria.star.toString() : null,
  priceBuckets: getPriceBuckets(searchCriteria),
  amenities: searchCriteria.amenities,
  structureTypes: searchCriteria.lodging,
  guestRating: searchCriteria.guestRating,
  paymentType: searchCriteria.paymentType,
  privacyTrackingState: getPrivacyState(context), // This will move into the context-adapter once all spinners have updated to latest bex-sdk
});

const getPriceBuckets = (searchCriteria: SearchCriteriaModel): number[] | null => {
  if (searchCriteria.price && searchCriteria.price.length > 0) {
    // Support for the url params that may be set on server render before we have the price bucket configs
    return searchCriteria.price.map(x => Number.parseInt(x, 10)).filter(i => i === 0 || i);
  }

  return null;
};

// This will move into the context-adapter once all spinners have updated to latest bex-sdk
const getPrivacyState = (context: ContextStore): PrivacyTrackingState | undefined => {
  if (context.site.optInPrivacyInfo && context.site.optInPrivacyInfo.set) {
    return context.site.optInPrivacyInfo.yesSelected ? PrivacyTrackingState.CAN_TRACK : PrivacyTrackingState.CAN_NOT_TRACK;
  }

  return undefined;
};
